import { IGroupExtension, ILayerBehavior, ILayerProps, LayerType } from '@/version-types';
import { InstanceData, InstanceDataType } from '../data';
import { getGroupExtension } from './utils';

interface ILayersBehaviors {
    [layerType: string]: ILayerBehavior;
}

const getKey = (layerType: LayerType, role?: string) => {
    if (role) {
        return `${layerType}-${role}`;
    }
    return layerType;
};

function getBehaviors(identity: string) {
    return InstanceData.getData(identity, InstanceDataType.Behaviors) as ILayersBehaviors;
}

export const getBehaviorKey = (layerOrLayerType: ILayerProps | LayerType, role?: string) => {
    if (typeof layerOrLayerType === 'string') {
        return getKey(layerOrLayerType, role);
    }
    const extension = getGroupExtension<IGroupExtension>(layerOrLayerType);
    return getKey(layerOrLayerType.layerType, extension?.role);
};

/**
 * 获取图层行为
 */
export function getBehavior(identity: string, layerOrLayerType: ILayerProps | LayerType) {
    if (!layerOrLayerType) return undefined;
    const behaviors = getBehaviors(identity);
    return behaviors[getBehaviorKey(layerOrLayerType)] ?? undefined;
}
